import { CommonInternalWorkType } from "./CommonInternalWorkType";

enum SpecificLogisticsInternalWorkType {
    LOAD = "LOAD",
    UNLOAD = "UNLOAD",
}

export type LogisticsInternalWorkType = CommonInternalWorkType | SpecificLogisticsInternalWorkType;
export const LogisticsInternalWorkType = { ...CommonInternalWorkType, ...SpecificLogisticsInternalWorkType };
